import { ref } from 'vue';
import { api } from '../api/api';
import { store } from '../stores/userStore';

const unreadCount = ref(0);
let checkInterval = null;

export function useUnreadMessages() {
  const checkUnreadMessages = async () => {
    if (!store.isAuthenticated) {
      unreadCount.value = 0;
      return;
    }
    
    try {
      const result = await api.apiQuery('GET', '/private/unreadMessages', {});
      unreadCount.value = result?.length || 0;
    } catch (e) {
      console.error('Failed to fetch unread messages:', e);
    }
  };

  const startPolling = () => {
    checkUnreadMessages();
    if (!checkInterval) {
      checkInterval = setInterval(checkUnreadMessages, 30000); // 60 seconds
    }
  };

  const stopPolling = () => {
    if (checkInterval) {
      clearInterval(checkInterval);
      checkInterval = null;
    }
  };

  return {
    unreadCount,
    checkUnreadMessages,
    startPolling,
    stopPolling
  };
}
